import defaultAxios from "axios";
import { Api_url } from "../config/config";
import { getCookie } from "../cookie/cookieUtils";

// testing
// Create a singleton axios instance
const apiClient = defaultAxios.create({
    baseURL: Api_url,
    headers: {
        "Content-Type": 'application/json',
        Accept: '*/*',
    }
});

// Request interceptor to automatically add auth token
apiClient.interceptors.request.use((config) => {
    // Read auth from cookie helper
    const authData = getCookie();
    let Token = authData ? authData.token : null;

    if (Token && config.headers) {
        config.headers.Authorization = `Bearer ${Token}`;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

// Response interceptor to unwrap data automatically
apiClient.interceptors.response.use(
    (response) => {
        let data = response.data;
        if (typeof data === 'string') {
            try { data = JSON.parse(data); } catch (e) { }
        }
        return data;
    },
    (error) => {
        const errorMsg = error.response?.data?.message || error.message || error.toString();
        console.error("[API Error Interceptor]:", errorMsg, error.response?.data || error);
        return Promise.reject(new Error(errorMsg));
    }
);

const errorCheck = (data: any) => {
    if (data?.statusCode == 200) {
        return data?.data;
    }
    else {
        const errorMsg = data?.message || "Operation failed";
        console.error("[API Business Logic Error]:", errorMsg, data);
        throw new Error(errorMsg);
    }
}

export const Api = {
    upload: async (data: FormData) => {
        try {
            return await apiClient.post("/upload", data, {
                headers: { "Content-Type": "multipart/form-data" }
            });
        } catch (error) {
            throw error;
        }
    },

    logIn: async (body: any) => {
        try {
            const data: any = await apiClient.post("auth/login", body);
            return errorCheck(data);
        } catch (error) {
            throw error;
        }
    },

    post: async (url: string, body: any) => {
        try {
            const data: any = await apiClient.post(url, body);
            return errorCheck(data);
        } catch (error) {
            throw error;
        }
    },

    put: async (url: string, body: any) => {
        try {
            const data: any = await apiClient.put(url, body);
            return errorCheck(data);
        } catch (error) {
            throw error;
        }
    },

    get: async (url: string) => {
        try {
            const data: any = await apiClient.get(url);
            return errorCheck(data);
        } catch (error) {
            throw error;
        }
    },

    delete: async (url: string) => {
        try {
            const data: any = await apiClient.delete(url);
            return errorCheck(data);
        } catch (error) {
            throw error;
        }
    }
};